export type ResultChekFirstChar = "up" | "down" | "neutral";
export function checkFirstChar(input: string): ResultChekFirstChar {
  if (!input || typeof input !== "string") return "neutral";
  const firstChar = input[0];

  if (firstChar === "-") {
    return "down";
  } else if (firstChar === "+") {
    return "up";
  } else {
    return "neutral";
  }
}
